import { useState, useRef } from 'react';
import DiceLogo from './DiceLogo';

export default function GamePhotoView({ hostName, onPhotoTaken, onSkip }) {
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (file) {
      setPreview({ url: URL.createObjectURL(file), file });
    }
  }

  async function handleConfirm() {
    if (!preview) return;
    setUploading(true);
    try {
      await onPhotoTaken(preview.file);
    } catch {
      setUploading(false);
    }
  }

  return (
    <div id="game-photo-view">
      <DiceLogo />
      <h2 className="game-photo-title">{hostName}, you're the host!</h2>
      <p className="game-photo-subtitle">Snap a selfie to be this game's icon.</p>

      <input
        type="file"
        ref={fileRef}
        accept="image/*"
        capture="user"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />

      {preview ? (
        <div className="game-photo-capture-area">
          <img className="game-photo-preview" src={preview.url} alt="Game selfie" />
          <button className="btn-link game-photo-retake" onClick={() => fileRef.current?.click()}>
            Retake
          </button>
        </div>
      ) : (
        <button className="game-photo-btn" onClick={() => fileRef.current?.click()}>
          <span className="game-photo-icon">🤳</span>
          <span>Open Camera</span>
        </button>
      )}

      <div className="game-photo-actions">
        <button
          className="btn-bank"
          disabled={!preview || uploading}
          onClick={handleConfirm}
        >
          {uploading ? 'Uploading...' : 'Let\'s Roll!'}
        </button>
        <button className="btn-link game-photo-skip" onClick={onSkip}>
          Skip for now
        </button>
      </div>
    </div>
  );
}
